module.exports = __webpack_public_path__ + "img/2.648a1ac0.png";